<template>
    <div>
        <div class="mb-20">
            <v-row justify="end" class="row--x-small">
                <v-col cols="9" sm="10" md="auto">
                    <v-text-field class="w-100 min-w-md-300px" v-model="filter.searchValue" placeholder="검색어를 입력하세요." hide-details outlined @keydown.enter="() => { search(true); }">
                    </v-text-field>
                </v-col>
                <v-col cols="3" sm="2" md="auto">
                    <v-btn @click="search()" class="h-100 w-100 w-md-100px color-white" color="grey-7">검색</v-btn>
                </v-col>
            </v-row>
        </div>

        <div class="pt-12 pt-lg-36 border-top border-color-black border-2 w-100">
            <v-row>
                <v-col cols="6" md="3" v-for="board, idx in boards" :key="idx">
                    <a :href=board.meta.href target='_blank' class="board-item d-block border border-color-light">
                        <div class="thumb-wrap">
                            <div class="thumb" :style="`background-image: url(${board.thumb})`"></div>
                        </div>
                        <div class="board-item__txt pa-20 px-md-22">
                            <p class="page-text--sm board-item__txt__tit mb-10 mb-lg-24">
                                {{board.subject}}
                            </p>
                            <p class="font-size-12 font-size-lg-14 line-height-1 color-grey-a">
                                {{board.createdAt.toDate()}}
                            </p>
                        </div>
                    </a>
                </v-col>
            </v-row>
        </div>

        <div class="mt-50 mt-lg-80">
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" @input="search()" />
        </div>

        <!-- <v-card v-for="board, idx in boards" :key="idx" width="300px">
            <v-card-title>{{board.subject}}</v-card-title>
            <a :href=board.meta.href target='_blank'>
                <v-img :src=board.thumb></v-img>
            </a>
        </v-card> -->
    </div>
</template>

<script>
import api from '@/api'

export default {
    data() {
        return {
            boards: [],
            // searchKeys: "제목",
            filter: {
                searchKey: this.$route.query.searchKey || "",
                searchValue: this.$route.query.searchValue || "",
                'code': 'press'
            },
            pageCount: 1,

            page: +this.$route.query.page || 1,

            limit: 10
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            this.search()
        },
        async search() {
            let { summary, boards } = await api.v1.boards.gets({ 
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                    },
                params: { 'code': 'press'
            }});

            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.boards = boards;
        }
    }
}
</script>

<style>
.thumb-wrap{
    padding-top: 100%;
}

.board-item{
    transition: 0.15s ease-out;
}

.board-item__txt__tit{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .board-item:hover{
        border-color: var(--v-primary-base) !important;
    }
}
@media (min-width:1200px){
}

</style>